// // import React, { useEffect, useState } from "react";
// // import "./Orders.scss";
// // import { TitleBar } from "../../../Global/TitleBar/TitleBar";
// // import { TopBar } from "../../TopBar/TopBar";
// // import { IoEyeOutline, IoSearchSharp } from "react-icons/io5";
// // import { GreyfilterButton, RedBordButton, ViewMoreButton } from "../../../Global/GlobalButton";
// // import { LuFilter } from "react-icons/lu";
// // import { GlobalTable } from "../../../Global/GlobalTable/GlobalTable";
// // import { FaArrowRotateLeft } from "react-icons/fa6";
// // import { HiOutlineBellAlert } from "react-icons/hi2";
// // import { BiSolidCoinStack } from "react-icons/bi";
// // import axios from "axios";
// // import { EXCHNAGE_UR_PAYMENTSL, EXCHNAGE_URL } from "../../../../Url/Url";
// // import { toast } from "react-toastify";
// // import { useSelector } from "react-redux";
// // import * as XLSX from 'xlsx';
// // import { useLoading } from "../../../LoadingContext"; // ✅ ADD THIS

// // export const Orders = () => {
// //     const { setLoading } = useLoading(); // ✅ ADD THIS - Global loader

// //   const [selectedRow, setSelectedRow] = useState(null);
// //   const [selectedOrders, setSelectedOrders] = useState(new Set());
// //   const [selectedRowsData, setSelectedRowsData] = useState([]);
// //   const [ordersData, setOrdersData] = useState([]);
// //   const eventIdGet = useSelector((state)=>state?.users?.id)
// //   const eventId = String(eventIdGet)


// //   const token = localStorage.getItem("token")



// //   const getAllOrders = async () => {
// //         setLoading(true); // ✅ Start global loader

// //     try {
// //       const response = await axios.get(`${EXCHNAGE_UR_PAYMENTSL}/getOrder/${eventId}`,{
// //         headers:{
// //           "Content-Type":"application/json",
// //           Authorization:`Bearer ${token}`,
// //         },
// //       });
// //       if(response.status === 200){
// //         const data = response?.data?.data
// //         console.log(data,"data")
// //         setOrdersData(data)
// //       }
// //     } catch (error) {
// //       toast.error("Error Fetching Order Details")
// //     }finally {
// //       setLoading(false); // ✅ Stop global loader
// //     }
// //   }

// //   useEffect(()=>{
// //     getAllOrders()
// //   },[])


// //   const formatDate = (dateString) => {
// //     const date = new Date(dateString);
// //     return date.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
// //   };

// //   const handleCheckboxChange = (order) => {
// //     setSelectedOrders((prevSelected) => {
// //       const newSelected = new Set(prevSelected);
// //       if (newSelected.has(order.id)) {
// //         newSelected.delete(order.id);
// //         setSelectedRowsData((prevData) => prevData.filter((row) => row.id !== order.id));
// //       } else {
// //         newSelected.add(order.id);
// //         setSelectedRowsData((prevData) => {
// //           if (!prevData.some((row) => row.id === order.id)) {
// //             return [...prevData, order];
// //           }
// //           return prevData;
// //         });
// //       }
// //       return newSelected;
// //     });
// //   };

// //   const columns = [
// //     "Select",
// //     "Order Reference No.",
// //     "Email",
// //     "First Name",
// //     "Last Name",
// //     "Submitted Date",
// //     "Actions",
// //   ];

// //   const data = ordersData.map((order) => ({
// //     Select: (
// //       <input
// //         type="checkbox"
// //         checked={selectedOrders.has(order.id)}
// //         onChange={() => handleCheckboxChange(order)}
// //       />
// //     ),
// //     "Order Reference No.": order.order_id,
// //     Email: order.user_email,
// //     "First Name": order.firstname,
// //     "Last Name": order.lastname,
// //     "Submitted Date": formatDate(order.created_at),
// //     Actions: (
// //       <div style={{ color: "#777777", cursor: "pointer", display: "flex", gap: "10px" }}>
// //         <IoEyeOutline style={{ width: "20px", height: "20px", color: "#333333" }} />
// //         <FaArrowRotateLeft style={{ width: "20px", height: "20px", color: "#333333" }} />
// //         <BiSolidCoinStack style={{ width: "20px", height: "20px", color: "#FFB238" }} />
// //         <HiOutlineBellAlert style={{ width: "20px", height: "20px", color: "#00AC4F" }} />
// //       </div>
// //     ),
// //   }));


// //   const handleExportCsv = () => {
// //     if (selectedRowsData.length === 0) {
// //       toast.error("No rows selected for export!");
// //       return;
// //     }
// //       const formattedData = selectedRowsData.map(({ order_id, user_email, firstname, lastname, created_at }) => ({
// //       "Order Reference No.": order_id,
// //       Email: user_email,
// //       "First Name": firstname,
// //       "Last Name": lastname,
// //       "Submitted Date": formatDate(created_at),
// //     }));
// //     const worksheet = XLSX.utils.json_to_sheet(formattedData);
// //     const workbook = XLSX.utils.book_new();
// //     XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");
  
// //     XLSX.writeFile(workbook, "SelectedOrders.xlsx");
// //     toast.success("Data Downloaded Successfully.")
// //     setSelectedRowsData([]);
// //   };

// //   console.log(selectedRowsData,"selectedRowData")
// //   return (
// //     <div>
// //       <div className="ordList_data_div">
// //         <TitleBar title="Event Order Lists" />
// //         <div className="ordList_white_bg">
// //           <TopBar titleheading="Event Order Lists" />

// //           <div className="ordList_table_div">
// //             <div className="ordList_table_search">
// //               <div className="ordList_table_icon">
// //                 <IoSearchSharp />
// //               </div>
// //               <div className="ordList_table_icon_content">
// //                 <input type="text" placeholder="Search here..." />
// //               </div>
// //             </div>

// //             <div className="ordList_filter_btn">
// //             <ViewMoreButton onClick={handleExportCsv} style={{ color: "#333333" }}>
// //                 Export CSV
// //               </ViewMoreButton>
// //               <RedBordButton  style={{ fontSize: "16px"}}>
// //                    Send Invitation
// //               </RedBordButton>

// //               <GreyfilterButton className="ordList_filter_icon">
// //                 <LuFilter />
// //                 Filter
// //               </GreyfilterButton>
// //             </div>
// //           </div>
// //         </div>

// //         <GlobalTable
// //           data={data}
// //           columns={columns}
// //           onRowClick={setSelectedRow}
// //         />
// //       </div>
// //     </div>
// //   );
// // };



// import React, { useEffect, useState } from "react";
// import "./Orders.scss";
// import { TitleBar } from "../../../Global/TitleBar/TitleBar";
// import { TopBar } from "../../TopBar/TopBar";
// import { IoEyeOutline, IoSearchSharp } from "react-icons/io5";
// import { GreyfilterButton, RedBordButton, ViewMoreButton } from "../../../Global/GlobalButton";
// import { LuFilter } from "react-icons/lu";
// import { GlobalTable } from "../../../Global/GlobalTable/GlobalTable";
// import { FaArrowRotateLeft } from "react-icons/fa6";
// import { HiOutlineBellAlert } from "react-icons/hi2";
// import { BiSolidCoinStack } from "react-icons/bi";
// import axios from "axios";
// import { EXCHNAGE_UR_PAYMENTSL, EXCHNAGE_URL } from "../../../../Url/Url";
// import { toast } from "react-toastify";
// import { useSelector } from "react-redux";
// import * as XLSX from 'xlsx';
// import { useLoading } from "../../../LoadingContext";

// export const Orders = () => {
//   const { setLoading } = useLoading();

//   const [selectedRow, setSelectedRow] = useState(null);
//   const [selectedOrders, setSelectedOrders] = useState(new Set());
//   const [selectedRowsData, setSelectedRowsData] = useState([]);
//   const [ordersData, setOrdersData] = useState([]);
//   const eventIdGet = useSelector((state)=>state?.users?.id)
//   const eventId = String(eventIdGet)

//   const token = localStorage.getItem("token")

//   const getAllOrders = async () => {
//     setLoading(true);
//     try {
//       const response = await axios.get(`${EXCHNAGE_UR_PAYMENTSL}/getOrder/${eventId}`,{
//         headers:{
//           "Content-Type":"application/json",
//           Authorization:`Bearer ${token}`,
//         },
//       });
//       if(response.status === 200){
//         const data = response?.data?.data
//         console.log(data,"data")
//         setOrdersData(data)
//       }
//     } catch (error) {
//       toast.error("No data available for orders");
//     } finally {
//       setLoading(false);
//     }
//   }

//   useEffect(()=>{
//     getAllOrders()
//   },[])

//   const formatDate = (dateString) => {
//     const date = new Date(dateString);
//     return date.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
//   };

//   const handleCheckboxChange = (order) => {
//     setSelectedOrders((prevSelected) => {
//       const newSelected = new Set(prevSelected);
//       if (newSelected.has(order.id)) {
//         newSelected.delete(order.id);
//         setSelectedRowsData((prevData) => prevData.filter((row) => row.id !== order.id));
//       } else {
//         newSelected.add(order.id);
//         setSelectedRowsData((prevData) => {
//           if (!prevData.some((row) => row.id === order.id)) {
//             return [...prevData, order];
//           }
//           return prevData;
//         });
//       }
//       return newSelected;
//     });
//   };

//   // ✅ Select All Orders
//   const handleSelectAll = () => {
//     const allOrderIds = ordersData.map(order => order.id);
//     setSelectedOrders(new Set(allOrderIds));
//     setSelectedRowsData([...ordersData]);
//     toast.success(`Selected ${ordersData.length} orders`);
//   };

//   // ✅ Deselect All Orders
//   const handleDeselectAll = () => {
//     setSelectedOrders(new Set());
//     setSelectedRowsData([]);
//     toast.info("All orders deselected");
//   };

//   const columns = [
//     "Select",
//     "Order Reference No.",
//     "Email",
//     "First Name",
//     "Last Name",
//     "Submitted Date",
//     "Actions",
//   ];

//   const data = ordersData.map((order) => ({
//     Select: (
//       <input
//         type="checkbox"
//         checked={selectedOrders.has(order.id)}
//         onChange={() => handleCheckboxChange(order)}
//       />
//     ),
//     "Order Reference No.": order.order_id,
//     Email: order.user_email,
//     "First Name": order.firstname,
//     "Last Name": order.lastname,
//     "Submitted Date": formatDate(order.created_at),
//     Actions: (
//       <div style={{ color: "#777777", cursor: "pointer", display: "flex", gap: "10px" }}>
//         <IoEyeOutline style={{ width: "20px", height: "20px", color: "#333333" }} />
//         <FaArrowRotateLeft style={{ width: "20px", height: "20px", color: "#333333" }} />
//         <BiSolidCoinStack style={{ width: "20px", height: "20px", color: "#FFB238" }} />
//         <HiOutlineBellAlert style={{ width: "20px", height: "20px", color: "#00AC4F" }} />
//       </div>
//     ),
//   }));

//   // ✅ Improved Export CSV with loader
//   const handleExportCsv = () => {
//     if (selectedRowsData.length === 0) {
//       toast.error("No rows selected for export! Please select at least one order.");
//       return;
//     }

//     setLoading(true);
//     try {
//       const formattedData = selectedRowsData.map(({ order_id, user_email, firstname, lastname, created_at }) => ({
//         "Order Reference No.": order_id || '',
//         Email: user_email || '',
//         "First Name": firstname || '',
//         "Last Name": lastname || '',
//         "Submitted Date": formatDate(created_at),
//       }));
      
//       // Auto-size columns
//       const worksheet = XLSX.utils.json_to_sheet(formattedData);
//       const colWidths = [];
//       Object.keys(formattedData[0] || {}).forEach((key) => {
//         let maxLength = key.length;
//         formattedData.forEach(row => {
//           const value = String(row[key] || '');
//           maxLength = Math.max(maxLength, value.length);
//         });
//         colWidths.push({ wch: Math.min(maxLength + 5, 50) });
//       });
//       worksheet['!cols'] = colWidths;

//       const workbook = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");
    
//       XLSX.writeFile(workbook, `Orders_${new Date().toISOString().slice(0,10)}.xlsx`);
//       toast.success(`Exported ${formattedData.length} orders successfully!`);
//       setSelectedRowsData([]);
//       setSelectedOrders(new Set());
//     } catch (error) {
//       console.error("Error exporting CSV:", error);
//       toast.error("Failed to export CSV");
//     } finally {
//       setLoading(false);
//     }
//   };

//   console.log(selectedRowsData,"selectedRowData");

//   return (
//     <div>
//       <div className="ordList_data_div">
//         <TitleBar title="Event Order Lists" />
//         <div className="ordList_white_bg">
//           <TopBar titleheading="Event Order Lists" />

//           <div className="ordList_table_div">
//             <div className="ordList_table_search">
//               <div className="ordList_table_icon">
//                 <IoSearchSharp />
//               </div>
//               <div className="ordList_table_icon_content">
//                 <input type="text" placeholder="Search here..." />
//               </div>
//             </div>

//             <div className="ordList_filter_btn">
//               {/* ✅ Select All Button */}
//               <ViewMoreButton
//                 style={{ color: "#333333" }}
//                 onClick={handleSelectAll}
//               >
//                 Select All
//               </ViewMoreButton>

//               {/* ✅ Deselect All Button */}
//               <ViewMoreButton
//                 style={{ color: "#333333" }}
//                 onClick={handleDeselectAll}
//               >
//                 Deselect All
//               </ViewMoreButton>

//               {/* ✅ Export CSV Button with count */}
//               <ViewMoreButton
//                 style={{ color: "#333333" }}
//                 onClick={handleExportCsv}
//                 disabled={selectedRowsData.length === 0}
//               >
//                 Export CSV ({selectedRowsData.length})
//               </ViewMoreButton>

//               {/* ✅ Send Invitation Button - disabled if no rows selected */}
//               <RedBordButton
//                 style={{ fontSize: "16px" }}
//                 disabled={selectedRowsData.length === 0}
//               >
//                 Send Invitation
//               </RedBordButton>

//               <GreyfilterButton className="ordList_filter_icon">
//                 <LuFilter />
//                 Filter
//               </GreyfilterButton>
//             </div>
//           </div>
//         </div>

//         <GlobalTable
//           data={data}
//           columns={columns}
//           onRowClick={setSelectedRow}
//         />
//       </div>
//     </div>
//   );
// };


import React, { useEffect, useState } from "react";
import "./Orders.scss";
import { TitleBar } from "../../../Global/TitleBar/TitleBar";
import { TopBar } from "../../TopBar/TopBar";
import { IoEyeOutline, IoSearchSharp } from "react-icons/io5";
import { GreyfilterButton, RedBordButton, ViewMoreButton } from "../../../Global/GlobalButton";
import { LuFilter } from "react-icons/lu";
import { GlobalTable } from "../../../Global/GlobalTable/GlobalTable";
import { FaArrowRotateLeft } from "react-icons/fa6";
import { HiOutlineBellAlert } from "react-icons/hi2";
import { BiSolidCoinStack } from "react-icons/bi";
import axios from "axios";
import { EXCHNAGE_UR_PAYMENTSL, EXCHNAGE_URL } from "../../../../Url/Url";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import * as XLSX from 'xlsx';
import { useLoading } from "../../../LoadingContext";

export const Orders = () => {
  const { setLoading } = useLoading();

  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedOrders, setSelectedOrders] = useState(new Set());
  const [selectedRowsData, setSelectedRowsData] = useState([]); 
  const [ordersData, setOrdersData] = useState([]);
  const eventIdGet = useSelector((state)=>state?.users?.id)
  const eventId = String(eventIdGet)

  const token = localStorage.getItem("token")

  const getAllOrders = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${EXCHNAGE_UR_PAYMENTSL}/getOrder/${eventId}`,{
        headers:{
          "Content-Type":"application/json",
          Authorization:`Bearer ${token}`,
        },
      });
      if(response.status === 200){
        const data = response?.data?.data
        console.log(data,"data")
        setOrdersData(data)
      }
    } catch (error) {
      toast.error("No data available for orders");
    } finally {
      setLoading(false);
    }
  }

  useEffect(()=>{
    getAllOrders()
  },[])

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
  };

  // ✅ Helper to format null values
  const formatNullValue = (value) => {
    if (value === null || value === undefined || value === "" || value === "null") {
      return <span style={{ color: "#999", fontStyle: "italic" }}>N/A</span>;
    }
    return value;
  };

  const handleCheckboxChange = (order) => {
    setSelectedOrders((prevSelected) => {
      const newSelected = new Set(prevSelected);
      if (newSelected.has(order.id)) {
        newSelected.delete(order.id);
        setSelectedRowsData((prevData) => prevData.filter((row) => row.id !== order.id));
      } else {
        newSelected.add(order.id);
        setSelectedRowsData((prevData) => {
          if (!prevData.some((row) => row.id === order.id)) {
            return [...prevData, order];
          }
          return prevData;
        });
      }
      return newSelected;
    });
  };

  // ✅ Select All Orders
  const handleSelectAll = () => {
    const allOrderIds = ordersData.map(order => order.id);
    setSelectedOrders(new Set(allOrderIds));
    setSelectedRowsData([...ordersData]);
    toast.success(`Selected ${ordersData.length} orders`);
  };

  // ✅ Deselect All Orders
  const handleDeselectAll = () => {
    setSelectedOrders(new Set());
    setSelectedRowsData([]);
    toast.info("All orders deselected");
  };

  // ✅ Updated Columns with GST/VAT/Company
  const columns = [
    "Select", 
    "Order Reference No.",
    "Email",
    "First Name",
    "Last Name",
    "GST Number",      // ✅ NEW
    "VAT Number",      // ✅ NEW
    "Company Name",    // ✅ NEW
    "Submitted Date",
    "Actions",
  ];

  const data = ordersData.map((order) => ({
    Select: (
      <input
        type="checkbox"
        checked={selectedOrders.has(order.id)}
        onChange={() => handleCheckboxChange(order)}
      />
    ),
    "Order Reference No.": order.order_id,
    Email: order.user_email,
    "First Name": order.firstname,
    "Last Name": order.lastname,
    "GST Number": formatNullValue(order.gst_number),      // ✅ GST
    "VAT Number": formatNullValue(order.vat_number),      // ✅ VAT
    "Company Name": formatNullValue(order.company_name),  // ✅ Company
    "Submitted Date": formatDate(order.created_at),
    Actions: (
      <div style={{ color: "#777777", cursor: "pointer", display: "flex", gap: "10px" }}>
        <IoEyeOutline style={{ width: "20px", height: "20px", color: "#333333" }} />
        <FaArrowRotateLeft style={{ width: "20px", height: "20px", color: "#333333" }} />
        <BiSolidCoinStack style={{ width: "20px", height: "20px", color: "#FFB238" }} />
        <HiOutlineBellAlert style={{ width: "20px", height: "20px", color: "#00AC4F" }} />
      </div>
    ),
  }));

  // ✅ Export CSV with GST/VAT/Company
  const handleExportCsv = () => {
    if (selectedRowsData.length === 0) {
      toast.error("No rows selected for export! Please select at least one order.");
      return;
    }

    setLoading(true);
    try {
      const formattedData = selectedRowsData.map(({ 
        order_id, 
        user_email, 
        firstname, 
        lastname, 
        gst_number, 
        vat_number, 
        company_name,
        created_at 
      }) => ({
        "Order Reference No.": order_id || '',
        Email: user_email || '',
        "First Name": firstname || '',
        "Last Name": lastname || '',
        "GST Number": gst_number || 'N/A',      // ✅ GST
        "VAT Number": vat_number || 'N/A',      // ✅ VAT
        "Company Name": company_name || 'N/A',  // ✅ Company
        "Submitted Date": formatDate(created_at),
      }));
      
      // Auto-size columns
      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      const colWidths = [];
      Object.keys(formattedData[0] || {}).forEach((key) => {
        let maxLength = key.length;
        formattedData.forEach(row => {
          const value = String(row[key] || '');
          maxLength = Math.max(maxLength, value.length);
        });
        colWidths.push({ wch: Math.min(maxLength + 5, 50) });
      });
      worksheet['!cols'] = colWidths;

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");
    
      XLSX.writeFile(workbook, `Orders_${new Date().toISOString().slice(0,10)}.xlsx`);
      toast.success(`Exported ${formattedData.length} orders successfully!`);
      setSelectedRowsData([]);
      setSelectedOrders(new Set());
    } catch (error) {
      console.error("Error exporting CSV:", error);
      toast.error("Failed to export CSV");
    } finally {
      setLoading(false);
    }
  };

  console.log(selectedRowsData,"selectedRowData");

  return (
    <div>
      <div className="ordList_data_div">
        <TitleBar title="Event Order Lists" />
        <div className="ordList_white_bg">
          <TopBar titleheading="Event Order Lists" />

          <div className="ordList_table_div">
            <div className="ordList_table_search">
              <div className="ordList_table_icon">
                <IoSearchSharp />
              </div>
              <div className="ordList_table_icon_content">
                <input type="text" placeholder="Search here..." />
              </div>
            </div>

            <div className="ordList_filter_btn">
              <ViewMoreButton 
                style={{ color: "#333333" }}
                onClick={handleSelectAll}
              >
                Select All
              </ViewMoreButton>

              <ViewMoreButton 
                style={{ color: "#333333" }}
                onClick={handleDeselectAll}
              >
                Deselect All
              </ViewMoreButton>

              <ViewMoreButton 
                style={{ color: "#333333" }}
                onClick={handleExportCsv}
                disabled={selectedRowsData.length === 0}
              >
                Export CSV ({selectedRowsData.length})
              </ViewMoreButton>

              <RedBordButton 
                style={{ fontSize: "16px" }}
                disabled={selectedRowsData.length === 0}
              >
                Send Invitation
              </RedBordButton>

              <GreyfilterButton className="ordList_filter_icon">
                <LuFilter />
                Filter
              </GreyfilterButton>
            </div>
          </div>
        </div>

        <GlobalTable
          data={data}
          columns={columns}
          onRowClick={setSelectedRow}
        />
      </div>
    </div>
  );
};